import { getAnalyticsDefaultParams } from './get-analytics-default-params'
import type { AnalyticsEventParams } from '@/shared/analytics/events'
import { analyticsEventNames } from '@/shared/analytics/events'
import { trackAnalyticsEvent } from '@/shared/analytics/track-analytics-event'

export const trackClickSignup = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.clickSignup,
    getAnalyticsDefaultParams(params),
  )
}

export const trackClickRequestDemo = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.clickRequestDemo,
    getAnalyticsDefaultParams(params),
  )
}

export const trackClickSubscr = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.clickSubscr,
    getAnalyticsDefaultParams(params),
  )
}

export const trackClickPilotProgram = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.clickPilotProgram,
    getAnalyticsDefaultParams(params),
  )
}

export const trackClickTelegram = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.clickTelegram,
    getAnalyticsDefaultParams(params),
  )
}

export const trackClickX = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.clickX,
    getAnalyticsDefaultParams(params),
  )
}

export const trackSubmitContactForm = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.submitContactForm,
    getAnalyticsDefaultParams(params),
  )
}

export const trackSubmitDemoRequest = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.submitDemoRequest,
    getAnalyticsDefaultParams(params),
  )
}

// — Funnel: Laplace x GTM instant demo —

export const trackGtmDemoSubmit = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.gtmDemoSubmit,
    getAnalyticsDefaultParams(params),
  )
}

export const trackGtmDemoCompleted = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.gtmDemoCompleted,
    getAnalyticsDefaultParams(params),
  )
}

export const trackGtmDemoFailed = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.gtmDemoFailed,
    getAnalyticsDefaultParams(params),
  )
}

export const trackClickGtmStartCampaign = (
  params?: AnalyticsEventParams,
): void => {
  trackAnalyticsEvent(
    analyticsEventNames.clickGtmStartCampaign,
    getAnalyticsDefaultParams(params),
  )
}

// — Funnel: activation —

export const trackSignUp = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.signUp,
    getAnalyticsDefaultParams({ method: 'email', ...params }),
  )
}

export const trackLogin = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.login,
    getAnalyticsDefaultParams({ method: 'email', ...params }),
  )
}

export const trackLogout = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.logout,
    getAnalyticsDefaultParams(params),
  )
}

export const trackWorkspaceCreated = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.workspaceCreated,
    getAnalyticsDefaultParams(params),
  )
}

// — Funnel: engagement —

export const trackChatStarted = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.chatStarted,
    getAnalyticsDefaultParams(params),
  )
}

export const trackMessageSent = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.messageSent,
    getAnalyticsDefaultParams(params),
  )
}

/**
 * Activation milestone — fires once per chat, on the very first message that
 * opens a new conversation. `message_sent` still fires for every message
 * (volume); this is the cleaner step for the activation funnel.
 */
export const trackFirstMessageSent = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.firstMessageSent,
    getAnalyticsDefaultParams(params),
  )
}

export const trackInviteAccepted = (params?: AnalyticsEventParams): void => {
  trackAnalyticsEvent(
    analyticsEventNames.inviteAccepted,
    getAnalyticsDefaultParams(params),
  )
}
